import React, { useState } from "react";

import TodoList from "./TodoList";
import TodoOptions from "./TodoOptions";
import LoadingCenter from "../LoadingCenter";

import { useTodos } from "./queries/useQuery";

const TodoContent = props => {
  const [option, updateOption] = useState("select_all");

  const { data, isLoading } = useTodos();

  if (isLoading) return <LoadingCenter />;

  return (
    <div className="todo__content">
      <TodoOptions option={option} updateOption={updateOption} />
      <TodoList data={data} option={option} />
    </div>
  );
}

export default TodoContent;